import React from "react";
import componentQueries from "react-component-queries";
import { Content } from "../Layout";
import Header from "../Header";

class MainLayout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inFrame: window !== window.top
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        //const { breakpoint } = this.props;
    }

    onContentClick = event => {
        // function lessThanMd(breakpoint) {
        //     return breakpoint === 'xs' || breakpoint === 'sm' || breakpoint === 'md'
        // }
    };

    checkBreakpoint = breakpoint => {
        switch (breakpoint) {
            case 'xs':
            case 'sm':
            case 'md':
                return false;

            case 'lg':
            case 'xl':
            default:
                return true;
        }
    };

    render() {
        const { children } = this.props;
        const { inFrame } = this.state;

        return (
            <main className="cr-app bg-light">
                <Content className="p-0" fluid onClick={this.onContentClick.bind(this)}>
                    {!inFrame && (<Header />)}
                    {children}
                </Content>
            </main>
        );
    }
}

const query = ({ width }) => {
    if (width < 575) {
        return { breakpoint: 'xs' };
    }

    if (576 < width && width < 767) {
        return { breakpoint: 'sm' };
    }

    if (768 < width && width < 991) {
        return { breakpoint: 'md' };
    }

    if (992 < width && width < 1199) {
        return { breakpoint: 'lg' };
    }

    if (width > 1200) {
        return { breakpoint: 'xl' };
    }

    return { breakpoint: 'xs' };
};

export default componentQueries(query)(MainLayout);